import { bool, func, string } from "prop-types";
import { useState } from "react";

import styled from "styled-components/macro";

import { motion } from "framer-motion";

import FnrModal from "UI/FnrModal";
import FnrModalCloseButton from "UI/FnrModalCloseButton";

import CopyButtonsList from "./CopyButtonsList";

DuplicateModal.propTypes = {
  defaultSelectedAction: string,
  setShow: func,
  show: bool,
};

export default function DuplicateModal({
  show,
  setShow,
  defaultSelectedAction,
}) {
  const [selectedAction, setSelectedAction] = useState(
    defaultSelectedAction || null
  );

  return (
    <FnrModal show={show}>
      <Wrapper>
        <Inside>
          <FnrModalCloseButton
            onClick={() => {
              setSelectedAction(null);
              setShow(false);
            }}
          />
          <Title>Report Actions</Title>
          <CopyButtonsList
            selectedAction={selectedAction}
            setSelectedAction={setSelectedAction}
            setShow={setShow}
          />
        </Inside>
      </Wrapper>
    </FnrModal>
  );
}

const Wrapper = styled(motion.div)`
  background: radial-gradient(
      farthest-side at bottom left,
      rgba(0, 233, 252, 0.4),
      transparent
    ),
    radial-gradient(farthest-corner at bottom right, #5d2881, transparent),
    radial-gradient(circle at top center, #242424, #000000);
  border-radius: 24px;
  color: #eceff0;
  max-width: 520px;
  overflow: hidden;
`;

const Inside = styled.div`
  border-radius: 24px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  padding: 24px;
`;

const Title = styled.div`
  font-size: 32px;
  font-weight: 400;
  opacity: 0.8;
  min-width: 400px;
  margin-bottom: 24px;
  text-shadow: rgba(0, 0, 0, 0.6) 1px 1px 4px;
`;
